/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_Some_HintInputs */

const en_us2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fixed ones stay marked; you fit the others into the week.`)
};

const pt_br2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fixos ficam marcados; os outros você encaixa na semana.`)
};

const es_419_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los fijos quedan marcados; los otros los acomodas en la semana.`)
};

const pt_pt2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fixos ficam marcados; os outros encaixas na semana.`)
};

const fr_fr2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les jours fixes restent cochés ; tu places les autres dans la semaine.`)
};

const de_de2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die festen bleiben markiert; die anderen verteilst du über die Woche.`)
};

const it_it2_profile_editors_same_some_hint = /** @type {(inputs: Profile_Editors_Same_Some_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelli fissi restano segnati; gli altri li incastri nella settimana.`)
};

/**
* | output |
* | --- |
* | "The fixed ones stay marked; you fit the others into the week." |
*
* @param {Profile_Editors_Same_Some_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_some_hint = /** @type {((inputs?: Profile_Editors_Same_Some_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_Some_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_some_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_some_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_some_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_some_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_some_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_some_hint(inputs)
	return en_us2_profile_editors_same_some_hint(inputs)
});
export { profile_editors_same_some_hint as "profile-editors.same_some_hint" }